window.__lc = window.__lc || {};
window.__lc.license || (window.__lc.license = parseInt("5762701"), window.__lc.integration_name = "Shopify", function(a, c, b) {
	function e(a) {
		return d._h ? d._h.apply(null, a) : d._q.push(a)
	}
	var d = {
		_q: [],
		_h: null,
		_v: "2.0",
		on: function() {
			e(["on", b.call(arguments)])
		},
		off: function() {
			e(["off", b.call(arguments)])
		},
		get: function() {
			if (!d._h) throw Error("[LiveChatWidget] You can't use getters before load.");
			return e(["get", b.call(arguments)])
		},
		call: function() {
			e(["call", b.call(arguments)])
		},
		init: function() {
			var a = c.createElement("script");
			a.async = !0;
			a.type = "text/javascript";
			a.src = "https://cdn.livechatinc.com/tracking.js";
			c.head.appendChild(a)
		}
	};
	!a.__lc.asyncInit && d.init();
	a.LiveChatWidget = a.LiveChatWidget || d
}(window, document, [].slice));
window.LiveChatCustomerCenter = {
	shopifyCustomerId: __st.cid || null,
	storeUUID: "5267f9fc-68df-4bdf-9617-0a7d7b174885",
	prepareVariables: function(a) {
		a = {
			cca_platform: "shopify",
			cca_store_id: this.storeUUID,
			cca_cart_content: JSON.stringify(a)
		};
		this.shopifyCustomerId && (a.cca_customer_id = this.shopifyCustomerId);
		return a
	},
	prepareLegacyVariables: function(a) {
		a = [{
			name: "cca_platform",
			value: "shopify"
		}, {
			name: "cca_store_id",
			value: this.storeUUID
		}, {
			name: "cca_cart_content",
			value: JSON.stringify(a)
		}];
		this.shopifyCustomerId && a.push({
			name: "cca_customer_id",
			value: this.shopifyCustomerId
		});
		return a
	},
	getAjax: function(a, c) {
		var b = window.XMLHttpRequest ? new XMLHttpRequest : new ActiveXObject("Microsoft.XMLHTTP");
		b.open("GET", a);
		b.onreadystatechange = function() {
			3 < b.readyState && 200 === b.status && c && c(b.responseText)
		};
		b.setRequestHeader("X-Requested-With", "XMLHttpRequest");
		b.send();
		return b
	},
	getPrice: function(a) {
		return parseFloat(a / 100).toFixed(2)
	},
	updateVariables: function(a) {
		window.LiveChatWidget ? window.LiveChatWidget.call("update_session_variables", this.prepareVariables(a)) : window.LC_API.update_custom_variables(this.prepareLegacyVariables(a))
	},
	mapDiscounts: function(a) {
		var c = this;
		return a.map(function(a) {
			return Object.assign({}, a, {
				amount: c.getPrice(a.amount)
			})
		})
	},
	setCartVariables: function(a) {
		var c = this,
			b = {
				subtotal: this.getPrice(a.original_total_price || 0),
				total: this.getPrice(a.total_price || 0),
				currency: a.currency,
				items: []
			};
		a.items.forEach(function(a) {
			var d = a.variant_id;
			b.items.push({
				id: a.id,
				qty: a.quantity,
				discounts: c.mapDiscounts(a.discounts),
				variantId: d
			})
		});
		this.updateVariables(b)
	},
	trackCart: function() {
		this.getAjax("/cart.js", function(a) {
			this.setCartVariables(JSON.parse(a))
		}.bind(this))
	},
	init: function() {
		this.trackCart();
		setInterval(this.trackCart.bind(this), "900000")
	}
};
if (window.LiveChatWidget) window.LiveChatWidget.on("ready", function() {
	window.LiveChatCustomerCenter.init()
    
    function onVisibilityChanged(data) {
        switch (data.visibility) {
          case "maximized":
            document.getElementById('chat-widget-container').classList.add('chat');
            break;
          case "minimized":
            document.getElementById('chat-widget-container').classList.remove('chat');
            break;
          case "hidden":
            break;
        }
      }
      
      LiveChatWidget.on('visibility_changed', onVisibilityChanged)

});
else window.LC_API && window.LiveChatCustomerCenter.init();